import numberUtils from "../_helpers/number-utils";

export const numberToGermanLocaleWithThousandSeperator = (number) => {
    if (numberUtils.isZeroOrNull(number)) {
        return "0,00";
    }
    return number.toLocaleString("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export const toGermanDateString = (date) => {
    if (!date) {
        return "";
    }
    return date.toLocaleDateString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
}

export const getBool = (stringBool) => {
    return stringBool && stringBool.toLowerCase() === "true";
}
